import * as AuthActionTypes from './AuthActionsTypes';
import { cognitoApiEndPoints } from '../../../constants/ApiEndPoints';
import ApiService from '../../../../src/services/api';
import {
  saveToken,
} from '../../../../src/utils/AuthUtils';
import { fetchUser } from '../user/userActions';
import { loaderAction } from '../loader/loaderActions';

/** Request Action type for fetching Login data */
export const fetchLoginRequest = (): any => ({
  type: AuthActionTypes.FETCH_LOGIN_REQUEST,
});
export const fetchLoginSuccess = (data = {}): any => ({
  type: AuthActionTypes.FETCH_LOGIN_SUCCESS,
  data,
});
export const fetchLoginFailure = (data: any): any => ({
  type: AuthActionTypes.FETCH_LOGIN_FAILURE,
  data,
});
export const setLoadingSignIn = (data: any): any => ({
  type: AuthActionTypes.SET_LOADING_SIGN_IN,
  data,
});

export const fetchEmail = (navigate: any) => async (dispatch: any) => {
  dispatch(setLoadingSignIn(true));
  try {
    const response = await ApiService.postData(
      cognitoApiEndPoints.userInfo,
      null,
      null,
      {},
    );

    const cognitoUserInfo = response.data;
    await dispatch(fetchUser(cognitoUserInfo));
    if (response.data.email) {
      navigate('/');
    }
  } catch (error: any) {
    if (error.response?.status === 401) {
      console.error('Unauthorized error, redirecting to login…');
    } else {
      console.error('Failed to fetch email:', error);
    }
  } finally {
    dispatch(setLoadingSignIn(false));
  }
};

export const cognitoLogin = (data: any, navigate: any) => async (dispatch: any) => {
  dispatch(fetchLoginRequest());
  dispatch(setLoadingSignIn(true));

  const payload = new URLSearchParams({
    grant_type: 'authorization_code',
    code: data?.code,
    redirect_uri: import.meta.env.VITE_SSO_CALLBACK_URL || '',
    client_id: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  }).toString();

  try {
    const response = await ApiService.postData(
      cognitoApiEndPoints.tokenURL,
      null,
      payload,
      { 'Content-Type': 'application/x-www-form-urlencoded' },
    );

    if (response.status === 200) {
      dispatch(fetchLoginSuccess(response.data));
      await saveToken(response.data);
      await dispatch(fetchEmail(navigate));
    } else if (response.status === 400) {
      dispatch(fetchLoginFailure('Invalid username or password'));
    }
    dispatch(loaderAction(false));
  } catch (error: any) {
    dispatch(fetchLoginFailure(error));
  } finally {
    dispatch(setLoadingSignIn(false));
  }
};
